import { render, staticRenderFns } from "./BatchQuestionDialog.vue?vue&type=template&id=0f2fff72&scoped=true"
import script from "./BatchQuestionDialog.vue?vue&type=script&lang=js"
export * from "./BatchQuestionDialog.vue?vue&type=script&lang=js"
import style0 from "./BatchQuestionDialog.vue?vue&type=style&index=0&id=0f2fff72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2fff72",
  null
  
)

export default component.exports